"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _utilities = require("../utilities");
var _HighlightedCardWrapperLabel = require("./HighlightedCardWrapperLabel.styles");
const _excluded = ["classes", "children", "color", "component", "endIcon", "startIcon"];
/**
 * A text element to display a label inside an `HighlightedCardWrapper` component.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-layout-highlightedcardwrapperlabel--page)
 */
const HighlightedCardWrapperLabel = _ref => {
  let {
      classes: classesOverrides,
      children,
      color = 'neutral',
      component,
      endIcon,
      startIcon
    } = _ref,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    classes,
    cx
  } = (0, _HighlightedCardWrapperLabel.useStyles)({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, classes[`color${(0, _utilities.capitalizeFirstWord)(color)}`])
  }, other), /*#__PURE__*/_react.default.createElement(_Label.default, {
    align: "center",
    classes: {
      root: classes.label,
      startIcon: classes.icon,
      endIcon: classes.icon
    },
    component: component,
    fontWeight: "bold",
    endIcon: endIcon,
    size: "xs",
    startIcon: startIcon
  }, children));
};
var _default = exports.default = HighlightedCardWrapperLabel;